import Vue from 'vue';

export default {
    find(parametros) {
        return Vue.axios.get("comida-cocina/find", { params: parametros }).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    get(id) {
        return Vue.axios.get("comida-cocina/" + id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    update(parametros) {
        return Vue.axios.put("comida-cocina", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    delete(id) {
        return Vue.axios.delete("comida-cocina/" + id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    store(parametros) {
        return Vue.axios.post("comida-cocina", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    }
}